import { preciseCurrencyFormatter } from '@shared/helpers/format-currency';
import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const LastCost: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Last Cost',
  minWidth: 60,
  accessorFn: (product) => preciseCurrencyFormatter(product.last_cost * product.standard_qty),
  toCSV: (product) => ({
    'Last Cost': product.last_cost.toFixed(2),
  }),
  gloss: 'Cost of one pack at the last receiving: last unit cost times standard quantity.',
});
